import React from 'react'

const PortfolioProjectAnalysis = () => {
  return (
    <div>PortfolioProjectAnalysis</div>
  )
}

export default PortfolioProjectAnalysis